import { CoreCarsComponent } from "@b2bportal/core-cars";
import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { ListError } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./CarListError.module.scss";
import { useCarsStyles } from "~core-cars/themes";

export type CarListErrorProps = PlatformComponentProps & {
  onErrorReload: () => void;
};

const COMPONENT_KEY = CoreCarsComponent.CarListError;

export const CarListError = ({
  className,
  children,
  onErrorReload,
}: CarListErrorProps) => {
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <ListError className={clsx(block, className)} onTapReload={onErrorReload}>
      {children}
    </ListError>
  );
};
